/**
 * TODO (SYWT-126):
 *
 * 1. Handle navigation menus. Think a utlility nav where the top level is a link.
 *    This module should inject a separate toggle mechanism than the link itself.
 * 2. Handle horizontal arrow key navigation.
 */

import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "wyatt-menu",
  class WyattMenu extends WYATTElement {
    constructor() {
      super();

      this.currentFocusIndex = 0;
      this.trigger = this.querySelector("[data-trigger]");
      this.menu = this.querySelector("[data-menu], ul");
      this.items = Array.from(
        this.menu.querySelectorAll("[data-item], a, button"),
      );

      this.trigger.addEventListener(
        "keydown",
        this.handleTriggerKeydown.bind(this),
      );
      this.trigger.addEventListener(
        "click",
        this.handleTriggerClick.bind(this),
      );

      this.items.forEach((menuItem) => {
        menuItem.addEventListener(
          "keydown",
          this.handleMenuItemKeydown.bind(this),
        );
      });

      this.boundHandleOutsideClick = this.handleOutsideClick.bind(this);
      document.addEventListener("click", this.boundHandleOutsideClick);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.boundHandleOutsideClick);
    }

    handleOutsideClick(event) {
      if (this.isOpen() && !this.menu.contains(event.target)) {
        this.closeMenu();
      }
    }

    handleTriggerClick(event) {
      if (this.isOpen()) {
        this.closeMenu();
      } else {
        this.openMenu();
      }

      event.stopPropagation();
      event.preventDefault();
    }

    handleTriggerKeydown(event) {
      let flag = false;

      switch (event.key) {
        case "ArrowDown":
          this.openMenu();
          this.setFocusTo(this.items[0]);
          flag = true;
          break;

        case "ArrowUp":
          this.openMenu();
          this.setFocusTo(this.items[this.items.length - 1]);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    handleMenuItemKeydown(event) {
      let flag = false;

      switch (event.key) {
        case "ArrowDown":
          this.setFocusToNext();
          flag = true;
          break;

        case "ArrowUp":
          this.setFocusToPrevious();
          flag = true;
          break;

        case "Home":
          this.setFocusTo(this.items[0]);
          flag = true;
          break;

        case "End":
          this.setFocusTo(this.items[this.items.length - 1]);
          flag = true;
          break;

        case "Tab":
          if (event.shiftKey) {
            this.setFocusToPrevious(true);
          } else {
            this.setFocusToNext(true);
          }
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    setFocusToNext(isTab = false) {
      const atEnd = this.currentFocusIndex === this.items.length - 1;

      if (atEnd && isTab) {
        this.closeMenu();
      } else if (atEnd) {
        this.setFocusTo(this.items[0]);
      } else {
        this.setFocusTo(this.items[this.currentFocusIndex + 1]);
      }
    }

    setFocusToPrevious(isTab = false) {
      const atStart = this.currentFocusIndex === 0;

      if (atStart && isTab) {
        this.closeMenu();
      } else if (atStart) {
        this.setFocusTo(this.items[this.items.length - 1]);
      } else {
        this.setFocusTo(this.items[this.currentFocusIndex - 1]);
      }
    }

    setFocusTo(element) {
      const newIndex = this.items.indexOf(element);

      element.focus();

      if (this.contains(document.activeElement)) {
        this.currentFocusIndex = newIndex;
      } else {
        this.closeMenu();
      }
    }

    openMenu() {
      this.menu.classList.remove("hidden");
      this.trigger.setAttribute("aria-expanded", "true");
      this.setFocusTo(this.items[0]);

      this.closeOtherMenus();
    }

    closeMenu(focusOnTrigger = true) {
      this.trigger.removeAttribute("aria-expanded");
      this.menu.classList.add("hidden");

      if (focusOnTrigger) {
        this.trigger.focus();
      }

      this.currentFocusIndex = 0;
    }

    isOpen() {
      return this.trigger.getAttribute("aria-expanded") === "true";
    }

    closeOtherMenus() {
      const allMenus = document.querySelectorAll("wyatt-menu");

      allMenus.forEach((menu) => {
        if (menu === this) {
          return;
        }

        menu.closeMenu(false);
      });
    }
  },
);
